module.exports = __webpack_public_path__ + "static/media/400025_01.161612c9.png";